import React from "react"
import styled from "styled-components"

import {FormattedMessage} from "@irati/utils/lang"
import {H2, Body} from "@irati/ui/src/Typography"
import imgSrc from "@irati/ui/images/merchanside_checkout_success.png"
import Flex from "@irati/ui/src/Flex"
import mainTheme from "@irati/ui/src/global/theme"

type Props = {
  userEmail: string
}

export const Content = ({userEmail}: Props) => {
  return (
    <Container direction="column" alignItems="center">
      <img src={imgSrc} alt="basket img" />
      <H2 marginTop={mainTheme.spacing.four} marginBottom={mainTheme.spacing.three}>
        <FormattedMessage id="flexiRewards.merchandise.success.header" />
      </H2>
      <Body>
        <FormattedMessage
          id="flexiRewards.merchandise.success.confirmationEmail"
          values={{
            email: userEmail
          }}
        />
      </Body>
    </Container>
  )
}

const Container = styled(Flex)`
  margin-top: ${({theme}) => theme.spacing.three}
    ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
  margin-top: ${theme.spacing.nine}
`};
`
